// In-memory-per-tab cache for /explore category tabs, so switching back to a
// category already fetched doesn't hit the API again. Backed by sessionStorage:
// scoped to a single browser tab and cleared automatically when that tab closes.
const CACHE_KEY = "te_blog_category_cache"

type BlogCategoryCache = Record<string, any[]>

const readCache = (): BlogCategoryCache => {
  if (typeof window === "undefined") return {}
  try {
    return JSON.parse(sessionStorage.getItem(CACHE_KEY) || "{}")
  } catch {
    return {}
  }
}

const writeCache = (cache: BlogCategoryCache) => {
  if (typeof window === "undefined") return
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache))
  } catch {
    // sessionStorage unavailable/full — caching is a pure optimization, safe to skip
  }
}

export const getCachedBlogCategory = (category: string): any[] | undefined => {
  return readCache()[category]
}

export const setCachedBlogCategory = (category: string, data: any[]) => {
  if (!data?.length) return
  const cache = readCache()
  cache[category] = data
  writeCache(cache)
}
